export default __webpack_public_path__ + "static/media/video-sdg-12.89bbdfd5.mp4";